"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SuperLink = _interopRequireDefault(require("../../../SuperLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Link = (0, _styledComponents["default"])(_SuperLink["default"]).attrs({
  mb: 2
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-weight: 500;\n  &:last-child {\n    margin-bottom: 0;\n  }\n  &:hover{\n    text-decoration: none;\n  }\n"], ["\n  font-weight: 500;\n  &:last-child {\n    margin-bottom: 0;\n  }\n  &:hover{\n    text-decoration: none;\n  }\n"])));
exports.Link = Link;
var templateObject_1;